import React from 'react'
import { Box, Grid, Typography, Card, CardMedia, Divider } from '@mui/material'
import ServicesHeader from './servicesHeader'
import './services.css'

import astroTurfExample1 from '../_content/astro1.webp'
import astroTurfExample2 from '../_content/astro2.webp'
import astroTurfExample3 from '../_content/astro3.webp'
import astroTurfExample4 from '../_content/after9.webp'
import astroTurfExample5 from '../_content/astro5.webp'
import astroTurfExample6 from '../_content/decking2.webp'
import astroTurfExample7 from '../_content/astro6.webp'
import astroTurfExample8 from '../_content/astro7.webp'

const AstroTurfServices = () => {
  return (
    <>
      <ServicesHeader
        background={astroTurfExample6}
        text="Artificial Grass (Astro Turf)"
      />

      {/* TOP STRIP */}
      <Divider orientation='vertical' flexItem sx={{ border: '1px solid white' }} />
      <Box className="top-strip">
        <Typography className="top-strip-text">
          Enjoy a perfectly green lawn all year round with low-maintenance artificial grass, covering Brentwood and Essex.
        </Typography>
      </Box>
      <Divider orientation='vertical' flexItem sx={{ border: '1px solid white' }} />

      {/* WHITE SECTION */}
      <Box className="section-wrapper">
        <Box className="section-inner">
          <Box className="section-content">

            <Typography className="section-heading" variant="h5">
              Realistic, durable lawns without the upkeep
            </Typography>

            <Typography className="section-subtext">
              Our artificial grass solutions provide a clean, natural-looking finish without the need for mowing, watering or the ongoing maintenance that comes with grass.
            </Typography>

            <Box className="section-divider" />

            <Grid container spacing={3} alignItems="stretch">
              {[
                {
                  title: 'Natural Look & Feel',
                  text: 'We use high-quality artificial grass that closely replicates the appearance and texture of real turf.',
                },
                {
                  title: 'Low Maintenance',
                  text: 'No mowing, watering or fertilising required — perfect for busy households and commercial spaces.',
                },
                {
                  title: 'Professional Installation',
                  text: 'Installed with precision for a smooth, long-lasting finish that performs well in all conditions.',
                },
              ].map((item, i) => (
                <Grid item xs={12} md={4} key={i} sx={{ display: 'flex' }}>
                  <Box className="service-card">
                    <Box>
                      <Typography className="card-title">{item.title}</Typography>
                      <Typography className="card-text">{item.text}</Typography>
                    </Box>
                  </Box>
                </Grid>
              ))}
            </Grid>

          </Box>
        </Box>
      </Box>

      {/* IMAGE SECTION */}
      <Box className="image-section">
        <Typography className="image-title" variant="h5">
          Recent Projects
        </Typography>

        <Grid container spacing={3} justifyContent="center">
          {[astroTurfExample7, astroTurfExample5, astroTurfExample6, astroTurfExample1, astroTurfExample8, astroTurfExample3, astroTurfExample4, astroTurfExample2].map((img, i) => (
            <Grid item xs={12} sm={6} md={4} key={i}>
              <Card className="image-card">
                <CardMedia
                  component="img"
                  image={img}
                  alt={`Artificial grass example ${i + 1}`}
                  className="image-media"
                />
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </>
  )
}

export default AstroTurfServices